import { YMapBounds } from '@search/ymap/src/bounds';
import React from 'react';
// import { useGql } from '@search/gql-client/src';
import { VTBCoreYMapDesktop } from '@search/vtbeco-frontend-core/view/common/components/YMap/Desktop';
// import { YMapPOI } from '@search/vtbeco-frontend-core/view/common/components/YMap/YMapPOI';

// import { InfrastructureList, NewBuildingPoi } from '@search/graphql-typings';
// import { getInfrastructureQuery } from '@search/classified-common/src/getInfrastructureQuery';
// import {
//     getInfrastructureQueryVariables,
//     getInfrastructureQueryResponse
// } from '@search/classified-common/src/__generated__/getInfrastructureQuery.graphql';
// import { YMapPlacemarkPriority } from '@search/ymap/src/Placemark';

export const YMapDesktop = ({
    children,
    noZoom,
    bounds,
    noPlacemark,
    setBounds,
    useChangedMargin,
    // showInfrastructure
}: {
    bounds?: YMapBounds;
    noZoom?: boolean;
    noPlacemark?: boolean;
    children?: React.ReactNode | React.ReactNode[];
    setBounds?: (bounds: YMapBounds) => void;
    useChangedMargin?: boolean;
    regionId: number;
    showInfrastructure?: boolean;
}) => {
    // eslint-disable-next-line max-len
    // const { data: { getInfrastructure } = { getInfrastructure: {} } }: InfrastructureList = useGql<getInfrastructureQueryVariables,
    //     getInfrastructureQueryResponse>(getInfrastructureQuery, {
    //         poiLimit: 20,
    //         bounds: {
    //             lx: bounds.min.x,
    //             ly: bounds.min.y,
    //             rx: bounds.max.x,
    //             ry: bounds.max.y
    //         }
    //     });

    return (
        <VTBCoreYMapDesktop
            noZoom={noZoom}
            noPlacemark={noPlacemark}
            useChangedMargin={useChangedMargin}
            bounds={bounds}
            setBounds={setBounds}
        >
            {/*{showInfrastructure && getInfrastructure?.poiList?.map((item: NewBuildingPoi) => (*/}
            {/*    <YMapPOI*/}
            {/*        key={`${item.longitude}-${item.latitude}`}*/}
            {/*        layerPriority={YMapPlacemarkPriority.Background}*/}
            {/*        {...item}*/}
            {/*    />*/}
            {/*))}*/}
            {children}
        </VTBCoreYMapDesktop>
    );
};
